import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import UserInfoHOC from '#components/HOC/UserInfoHOC'
import KapitelIcon from '#components/svg/icons/NavAusbildungsplan'
import StyledText from '#components/a/StyledText'
import {useAusbildungsplan} from '#hooks/useAusbildungsplan'
import {routeHelper} from '#config/routeKeys'

export function KapitelFreigebenBenachrichtigung(props) {
  const {onNotificationClick, currentUserId, kapitelId} = props
  const {getTitleForChapter} = useAusbildungsplan(currentUserId)
  const getKapitelName = () => getTitleForChapter(props.kapitelId)

  function onClickNotification() {
    onNotificationClick(routeHelper.ausbildungsplanQuestionsChapter(currentUserId, kapitelId))
  }

  const text = i18n.t('notification_text_kapitel_freigeben', [getKapitelName()])

  return (
    <div
      role="button"
      tabIndex={0}
      className="notification"
      onClick={onClickNotification}
      onKeyPress={onClickNotification}
    >
      <div className="notification__icon">
        <KapitelIcon />
      </div>
      <StyledText text={text} modifier="notification" />
    </div>
  )
}

KapitelFreigebenBenachrichtigung.propTypes = {
  currentUserId: PropTypes.number.isRequired,
  kapitelId: PropTypes.string.isRequired,
  onNotificationClick: PropTypes.func.isRequired,
}

export default UserInfoHOC(KapitelFreigebenBenachrichtigung, ['senderId'])
